
// API Routes

// const staging = 'https://bsptrips.staging.vggdev.com/api/';
const test = 'https://api.test.trips.ng/api/';
const ocrTest = 'https://ocr-passport-processor-prod.azurewebsites.net/api/';

// @ts-ignore
export const BASE_API_URL = process.env.NODE_ENV === 'development' ? test : `${window.env?.baseApiUrl}/api/`;
export const AIRLINE_BASE_API_URL = process.env.NODE_ENV === 'development' ? "https://avd.staging.vggdev.com/api/airline/" : "https://avd.prod.vggdev.com/api/airline/";
// @ts-ignore
export const PAYMENT_HUB_URL = process.env.NODE_ENV === 'development' ? 'https://api.test.trips.ng/paymentHub' : `${window.env?.baseApiUrl}/paymentHub`
// @ts-ignore
export const OCR_UPLOAD_URL = process.env.NODE_ENV === 'development' ? ` ${ocrTest}/traveler/ocr` : `${window.env?.ocrUploadUrl}/api/traveler/ocr`;
 

// export const VALIDATE_TOKEN_API_URL = 'account/validateToken';
export const VALIDATE_TOKEN_API_URL = 'v3/account/validateToken';

// API Paths 
export const SEARCH_DOMESTIC_FLIGHTS_URL = 'Flight/Domestic/SearchFlight';
export const SEARCH_INTERNATIONAL_FLIGHTS_URL = 'Flight/SearchFlight';
export const GET_AIRPORTS_API_URL = 'airport';
export const GET_DOMESTIC_AIRPORTS_API_URL = 'airport?countryCode=NG';
export const GET_INTERNATIONAL_AIRPORTS_API_URL = 'airport?isLocal=false';
// export const CONFIRM_DOMESTIC_TICKET_URL = 'Flight/Domestic/ConfirmTicketPrice';
export const CONFIRM_DOMESTIC_TICKET_URL = 'v3/Flight/Domestic/ConfirmTicketPrice';
// export const CONFIRM_TICKET_URL = 'Flight/ConfirmTicketPrice';
export const CONFIRM_TICKET_URL = 'v3/Flight/ConfirmTicketPrice';
export const BOOK_DOMESTIC_TICKET_URL = 'Flight/Domestic/BookFlight';
export const BOOK_TICKET_URL = 'Flight/BookFlight';
export const SEARCH_RESERVATION_URL = 'Flight/MyReservation';
export const GET_FLIGHT_FARE_RULES = 'Flight/FlightRules';
export const GET_AIRLINES = 'search';
export const APPLY_CREDIT = 'v3/Flight/ApplyCredit'
export const INITIATE_PAYMENT_URL = 'Payment/InitiatePayment';
export const CONFIRM_PAYMENT_URL = 'Payment/ConfirmPayment';
export const GET_USER_TRAVELERS_URL = 'Travelers/getTravelerByUserId';

// Bus Trips
export const GET_SUPPORTED_ROAD_ROUTES = 'Bus/GetSupportedRoutes?CountryCode=KE';
export const SEARCH_BUS_ROUTES = 'Bus/SearchBusverbose';
export const ROAD_BOOKING_URL = 'Bus/BookBus';
export const ROAD_CONFIRM_TICKET_URL = 'Bus/ConfirmTicketPrice';
export const GET_ROAD_FARE_RULES = 'Bus/TravelRules';
export const SEARCH_ROAD_RESERVATION_URL = 'Bus/MyReservation';

export const LOGIN_URL = 'Auth/login/email';
export const VERIFY_OTP_URL = 'Auth/verify';
export const RESEND_OTP_URL = 'Auth/resendotp';
export const GOOGLE_LOGIN = 'Auth/login/google';
export const USER = '/User';


export const GOOGLE_CALLBACK_URL = '/callback'

export const APP_NAME = 'Bsp Trips';

export const SUPPORTED_LANGUAGES = ['sw', 'en', 'fr', 'sp'];
export const LANGUAGES_OPTIONS = [{ label: 'English', value: 'en' },
{ label: 'French', value: 'fr' },
{ label: 'Spanish', value: 'sp' },
{ label: 'Swahili', value: 'sw' },
];

export const EXTERNAL_PAYMENT_CHANNEL = 1;
export const TRIPS_PAYMENT_CHANNEL = 2;

export enum PaymentGateway {
  CARD = 1,
  MPESA = 2,
  WALLET = 3,
}

export const PAYMENT_GATEWAY_MAPPING: Record<string, PaymentGateway> = {
  card: PaymentGateway.CARD,
  mpesa: PaymentGateway.MPESA,
  wallet: PaymentGateway.WALLET,
};

// export const GOOGLE_FEEDBACK_SHEET_URL = "https://script.google.com/macros/s/AKfycbz2YLA9O65VPyhKhrXp8WVsGZysYZRU1A7n2IJssxc3PNjyN4kFtZ6bVqAPPlgCNZZ0mw/exec";
export const GOOGLE_FEEDBACK_SHEET_URL = "https://script.google.com/macros/s/AKfycbxyBtEP8Zp2FpZMlUK7chLtLoQsydwrpkvYuLtIOsHIXyE_sqG7LJ7WmSbHQgc_4vsONQ/exec";



